import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Vehicle } from '@/types/vehicle'

export function updateVehicle(body: Vehicle): Promise<AxiosResponse<Vehicle>> {
  return instance.put(`/vehicle/${body.uuid}`, body)
}
